import { useCallback, useState } from 'react';
import { DateSelector, MoreCalculators, Result } from '../../components';
import { getAgeDifference } from '../../utils';
import './AgeDifference.scss';

export const AgeDifference = () => {
  const [firstDate, setFirstDate] = useState(() => new Date('1990-01-01'));
  const [secondDate, setSecondDate] = useState(() => new Date('2001-01-01'));
  const [ageDifference, setAgeDifference] = useState(() =>
    getAgeDifference(firstDate, secondDate)
  );
  const [showLoader, setShowLoader] = useState(false);

  const calculate = useCallback(() => {
    setShowLoader(true);
    setAgeDifference(() => getAgeDifference(firstDate, secondDate));
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);
  }, [firstDate, secondDate]);

  return (
    <>
      <div className='page p-4 rounded border mb-5'>
        <h2>Age Difference Calculator</h2>
        <p className='mb-4'>
          Calculate the age difference between two persons given their dates of
          birth.
        </p>
        <section className='input border rounded p-4 mb-5'>
          <DateSelector
            label='Select First Date of Birth'
            initDate={firstDate}
            setDate={setFirstDate}
            maxDate={new Date()}
          />
          <DateSelector
            label='Select Second Date of Birth'
            initDate={secondDate}
            setDate={setSecondDate}
            maxDate={new Date()}
          />
          <button
            className='btn btn-success d-block w-100 py-2 fw-bold'
            onClick={calculate}
          >
            Calculate
          </button>
        </section>
        <Result showLoader={showLoader}>
          <h4>Result:</h4>
          <p
            className='mb-0'
            dangerouslySetInnerHTML={{ __html: ageDifference }}
          />
        </Result>
      </div>
      <MoreCalculators />
    </>
  );
};
